import React from "react";
import DMModuleSubtopic from "../DMModuleSubtopic";

const BooleanAlgebra = () => (
  <DMModuleSubtopic
    title="Boolean algebra"
    videos={[
      "https://www.youtube.com/embed/l0NZ-pO-eho",
      "https://www.youtube.com/embed/pvsRgRbU0a8",
      "https://www.youtube.com/embed/YmKmS9bpMqM",
      "https://www.youtube.com/embed/ao2glpwkFUg",
      "https://www.youtube.com/embed/cMCB7D_rUGo",
      "https://www.youtube.com/embed/uacotpG4ZXw",
      "https://www.youtube.com/embed/ju73nvQkwpg?list=PL8xmnXn7pVtyHBjeIHOnm6ts-i57qRfWI",
      "https://www.youtube.com/embed/ulJRt1nmGog?list=PL8xmnXn7pVtyHBjeIHOnm6ts-i57qRfWI"
    ]}
    takeaways={[
        {image:"/dm_25.png"}
    ]}
    questions={[
      {
        text: "Expand the given Boolean expression x1*x2 in an equivalent sum of products canonical form and product of sums canonical forms in terms of three variables namely x1, x2 and x3"
      },
      {
        text: "Prove the following using Boolean Algebra: a = b ⇔ a.b'+a'.b = 0"
      },
      {
        text: "Simplify the Boolean Expression xy'z'+xyz'+xyz+xy'z+x'y'z"
      },
      {
        text:"Let P(S) be the power set of a non-empty set S. Let the operations join (+), meet (*) and complement (') be defined on P(S) as follows: A+B=A U B A*B=A ∩ B and A' =S-A for all A,B ∈ P(S). Show that< P(S),+,*,'> is a Boolean Algebra."
      },
      {
        text:"State and prove De Morgan’s laws in a Boolean Algebra"
      },
      {image:"/dm_26.png"},
      {image:"/dm_27.png"},
      {image:"/dm_28.png"},
      {image:"/dm_29.png"}
    ]}
    exampleVideos={[]}
  />
);

export default BooleanAlgebra;
